import React, { useState, useEffect } from "react"
import SButton from "components/Common/Button"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SelectBox from "components/Common/SelectBox"
import Breadcrumb from "components/Common/Breadcrumb"
import {
  Row,
  Col,
  Table,
  Spinner,
  Container,
  Card,
  CardBody,
  Modal,
  ModalBody,
} from "reactstrap"
import { getFabricByIdAPI, putFabricAPI } from "helpers/fabric_resource"
import { getSeason } from "store/season/actions"
import { getFabricTradingListResource } from "store/actions"
import { useHistory, useParams } from "react-router-dom"
import { RadioGroup, Radio } from "react-radio-input"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import BackButton from "components/Common/BackButton"

function EditFabric() {
  const history = useHistory()
  const dispatch = useDispatch()
  let { id } = useParams()
  const fabricTredingStore = useSelector(({ fabricTreding }) => fabricTreding)
  const seasonStore = useSelector(({ season }) => season)

  const [isProcessing, setIsProcessing] = useState(false)
  const [unitPricesIndex, setUnitPricesIndex] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)
  const [field, setField] = useState(null)

  const [unitPrices, setUnitPrices] = useState({
    seasonId: 0,
    seasonName: "",
    year: 0,
    unitPrice: 0,
    rank: 0,
  })

  const [customValidation, setCustomValidation] = useState({
    errorSeason: {
      status: false,
      message: "シーズン 必須項目です。",
    },
    errorYear: {
      status: false,
      message: "年度 必須項目です。",
    },
    errorUnitPrice: {
      status: false,
      message: "単価 必須項目です。",
    },
    errorRank: {
      status: false,
      message: "ランク 必須項目です。",
    },

    errorCompanyId: {
      status: false,
      message: "生地商社 必須項目です。",
    },
    errorBunch: {
      status: false,
      message: "バンチ名 必須項目です。",
    },
    errorNumber: {
      status: false,
      message: "生地番号 必須項目です。",
    },
    errorBrand: {
      status: false,
      message: "ブランド名 必須項目です。",
    },
  })

  const onChange = e => {
    let { name, value } = e.target
    setField({ ...field, [name]: value })

    if (name === "bunch") {
      setCustomValidation({
        ...customValidation,
        errorBunch: {
          ...customValidation.errorBunch,
          status: false,
        },
      })
    }

    if (name === "brand") {
      setCustomValidation({
        ...customValidation,
        errorBrand: {
          ...customValidation.errorBrand,
          status: false,
        },
      })
    }

    if (name === "number") {
      setCustomValidation({
        ...customValidation,
        errorNumber: {
          ...customValidation.errorNumber,
          status: false,
        },
      })
    }
  }

  const onChangeUnitPrices = e => {
    let { name, value } = e.target
    setUnitPrices({ ...unitPrices, [name]: Number(value) })
    if (name === "year") {
      setCustomValidation({
        ...customValidation,
        errorYear: { ...customValidation.errorYear, status: false },
      })
    } else if (name === "seasonId") {
      setCustomValidation({
        ...customValidation,
        errorSeason: { ...customValidation.errorSeason, status: false },
      })
    } else if (name === "rank") {
      setCustomValidation({
        ...customValidation,
        errorRank: { ...customValidation.errorRank, status: false },
      })
    } else if (name === "unitPrice") {
      setCustomValidation({
        ...customValidation,
        errorUnitPrice: { ...customValidation.errorUnitPrice, status: false },
      })
    }
  }

  const onSubmitUnitPrices = () => {
    let error = 0
    let defaultError = { ...customValidation }

    if (unitPrices.year === 0) {
      defaultError = {
        ...defaultError,
        errorYear: { ...defaultError.errorYear, status: true },
      }

      error += 1
    }
    if (unitPrices.seasonId === 0) {
      defaultError = {
        ...defaultError,
        errorSeason: { ...defaultError.errorSeason, status: true },
      }

      error += 1
    }
    if (unitPrices.rank === 0) {
      defaultError = {
        ...defaultError,
        errorRank: { ...defaultError.errorRank, status: true },
      }

      error += 1
    }
    if (unitPrices.unitPrice === 0) {
      defaultError = {
        ...defaultError,
        errorUnitPrice: { ...defaultError.errorUnitPrice, status: true },
      }

      error += 1
    }

    setCustomValidation(defaultError)
    if (error === 0) {
      let _temp = [...field?.unitPrices]
      if (isEdit) {
        Object.assign(_temp[unitPricesIndex], unitPrices)
      } else {
        _temp.push(unitPrices)
      }

      // set state
      setField({ ...field, unitPrices: _temp })

      // reset unit prices state
      setUnitPrices({
        seasonId: 0,
        year: 0,
        unitPrice: 0,
        rank: 0,
      })
      setUnitPricesIndex(null)
      setIsEdit(false)
      toggle()
    }
  }

  const companyValue =
    fabricTredingStore?.status === "success" &&
    fabricTredingStore?.dataForList
      ?.map(item => {
        return {
          label: item?.name,
          value: item?.id,
        }
      })
      .find(a => a?.value === field?.companyId)

  const seasonValue =
    seasonStore?.status === "success" &&
    seasonStore?.data
      ?.map(item => {
        return {
          label: item?.name,
          value: item?.id,
        }
      })
      .find(a => a?.value === unitPrices.seasonId)

  const yearOption = [
    {
      label: 2022,
      value: 2022,
    },
    {
      label: 2023,
      value: 2023,
    },
    {
      label: 2024,
      value: 2024,
    },
    {
      label: 2025,
      value: 2025,
    },
    {
      label: 2026,
      value: 2026,
    },
    {
      label: 2027,
      value: 2027,
    },
    {
      label: 2028,
      value: 2028,
    },
    {
      label: 2029,
      value: 2029,
    },
    {
      label: 2030,
      value: 2030,
    },
  ]

  const onSubmit = async () => {
    setIsProcessing(true)
    try {
      let error = 0
      let defaultError = { ...customValidation }

      if (field.companyId === 0 || !field.companyId) {
        defaultError = {
          ...defaultError,
          errorCompanyId: { ...defaultError.errorCompanyId, status: true },
        }

        error += 1
      }
      if (field.bunch === "" || !field.bunch) {
        defaultError = {
          ...defaultError,
          errorBunch: { ...defaultError.errorBunch, status: true },
        }

        error += 1
      }
      if (field.brand === "" || !field.brand) {
        defaultError = {
          ...defaultError,
          errorBrand: { ...defaultError.errorBrand, status: true },
        }

        error += 1
      }
      if (field.number === 0 || !field.number) {
        defaultError = {
          ...defaultError,
          errorNumber: { ...defaultError.errorNumber, status: true },
        }

        error += 1
      }

      setCustomValidation(defaultError)

      if (error === 0) {
        await putFabricAPI(field, id)

        history.push("/master/dough")

        setUnitPrices({
          seasonId: 0,
          year: 0,
          unitPrice: 0,
          rank: 0,
        })
        setField({
          companyId: 0,
          bunch: "",
          brand: "",
          number: "",
          mixedRatio: "",
          clothWidth: 0,
          outOfStock: true,
          unitPrices: [],
        })
      }

      setIsProcessing(false)
    } catch (error) {
      setIsProcessing(false)
    }
  }

  const fetchDataById = async () => {
    try {
      let { data } = await getFabricByIdAPI(id)
      setField(data)
    } catch (error) {
      console.log("error: ", error.response)
    }
  }

  useEffect(() => {
    if (id) {
      fetchDataById()
    }
  }, [id])

  useEffect(() => {
    dispatch(getFabricTradingListResource())
    dispatch(getSeason("", true))
  }, [])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"生地マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={8}>
                <p className="fw-bold">生地マスター詳細</p>
              </Col>
              <Col className="d-flex justify-content-end">
                <SButton
                  disabled={isProcessing}
                  onClick={onSubmit}
                  className="button"
                >
                  {isProcessing ? <Spinner size="sm" color="light" /> : "保存"}
                </SButton>
                <BackButton className="ms-2 button" />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <SelectBox
                  className="mb-2"
                  options={
                    fabricTredingStore?.status === "success" &&
                    fabricTredingStore?.dataForList?.map(val => {
                      return {
                        label: val.name,
                        value: val.id,
                      }
                    })
                  }
                  value={companyValue}
                  label={
                    <>
                      生地商社<span className="text-danger">*</span>
                    </>
                  }
                  name="companyId"
                  onChange={e => setField({ ...field, companyId: e?.value })}
                />
                {customValidation.errorCompanyId.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorCompanyId.message}
                  </p>
                )}

                <TextInputWithLabel
                  className="mb-2"
                  label={
                    <>
                      ブランド名<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="text"
                  name="brand"
                  value={field?.brand}
                  onChange={onChange}
                />
                {customValidation.errorBrand.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorBrand.message}
                  </p>
                )}
                <TextInputWithLabel
                  className="mb-2"
                  label={
                    <>
                      バンチ名<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="text"
                  name="bunch"
                  value={field?.bunch}
                  onChange={onChange}
                />
                {customValidation.errorBunch.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorBunch.message}
                  </p>
                )}
                <TextInputWithLabel
                  className="mb-2"
                  label={
                    <>
                      生地番号<span className="text-danger">*</span>
                    </>
                  }
                  placeholder={""}
                  type="text"
                  name="number"
                  value={field?.number}
                  onChange={onChange}
                />
                {customValidation.errorNumber.status && (
                  <p style={{ color: "red" }}>
                    {customValidation.errorNumber.message}
                  </p>
                )}
                <TextInputWithLabel
                  className="mb-2"
                  label={"生地巾"}
                  placeholder={""}
                  type="text"
                  name="clothWidth"
                  value={field?.clothWidth}
                  onChange={onChange}
                />
                <TextInputWithLabel
                  isTextArea
                  className="mb-2"
                  label={"混率"}
                  name="mixedRatio"
                  value={field?.mixedRatio}
                  onChange={onChange}
                />

                {field ? (
                  <div>
                    <label className="form-label">品切れ</label>
                    <RadioGroup
                      className="d-flex"
                      name="outOfStock"
                      onChange={value =>
                        setField({ ...field, outOfStock: value })
                      }
                      selectedValue={field?.outOfStock}
                    >
                      <label className="d-flex align-items-center me-5">
                        <Radio value={true} />
                        <span className="ms-2">はい</span>
                      </label>
                      <label className="d-flex align-items-center">
                        <Radio value={false} />
                        <span className="ms-2">いいえ</span>
                      </label>
                    </RadioGroup>
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>

            <Card>
              <CardBody>
                <Row>
                  <Col className="d-flex justify-content-end mb-2 " md={12}>
                    <SButton onClick={toggle} className="button">
                      登録
                    </SButton>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Table bordered>
                      <thead>
                        <tr>
                          <th>年度</th>
                          <th>シーズン</th>
                          <th>単価</th>
                          <th>ランク</th>
                          <th>登録日</th>
                          <th>編集</th>
                        </tr>
                      </thead>
                      <tbody>
                        {field?.unitPrices.map((item, index) => {
                          return (
                            <tr key={index} style={{ minWidth: 100 }}>
                              <td>{item.year}</td>
                              <td>{item.seasonName}</td>
                              <td>{item.unitPrice}</td>
                              <td>{item.rank}</td>
                              <td>{item.registrationDate}</td>
                              <td>
                                <SButton
                                  onClick={() => {
                                    setUnitPricesIndex(index)
                                    setUnitPrices(item)
                                    setIsEdit(true)
                                    toggle()
                                  }}
                                  size="sm"
                                  className="button"
                                >
                                  編集
                                </SButton>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Modal isOpen={modal} toggle={toggle}>
              <ModalBody>
                <Col md={12}>
                  <SelectBox
                    className="mb-2"
                    options={yearOption}
                    onChange={e => {
                      setUnitPrices({ ...unitPrices, year: e?.value })
                      setCustomValidation({
                        ...customValidation,
                        errorYear: {
                          ...customValidation.errorYear,
                          status: false,
                        },
                      })
                    }}
                    value={yearOption.find(a => a.value === unitPrices.year)}
                    label="年度"
                  />
                  {customValidation.errorYear.status && (
                    <p style={{ color: "red" }}>
                      {customValidation.errorYear.message}
                    </p>
                  )}
                  <SelectBox
                    className="mb-2"
                    options={
                      seasonStore?.status === "success" &&
                      seasonStore?.data.map(val => {
                        return {
                          value: val.id,
                          label: val.name,
                        }
                      })
                    }
                    onChange={e => {
                      setUnitPrices({
                        ...unitPrices,
                        seasonId: e?.value,
                        seasonName: e.label,
                      })
                      setCustomValidation({
                        ...customValidation,
                        errorSeason: {
                          ...customValidation.errorSeason,
                          status: false,
                        },
                      })
                    }}
                    value={seasonValue}
                    label="シーズン"
                  />
                  {customValidation.errorSeason.status && (
                    <p style={{ color: "red" }}>
                      {customValidation.errorSeason.message}
                    </p>
                  )}
                  <TextInputWithLabel
                    className="mb-2"
                    label={"単価"}
                    placeholder={""}
                    type="text"
                    name="unitPrice"
                    value={unitPrices.unitPrice}
                    pattern="^[0-9.]*$"
                    onChange={e => {
                      if (!e.target.validity.patternMismatch) {
                        onChangeUnitPrices(e)
                      }
                    }}
                  />
                  {customValidation.errorUnitPrice.status && (
                    <p style={{ color: "red" }}>
                      {customValidation.errorUnitPrice.message}
                    </p>
                  )}

                  <TextInputWithLabel
                    className="mb-2"
                    label={"ランク"}
                    placeholder={""}
                    type="text"
                    name="rank"
                    value={unitPrices.rank}
                    pattern="^[0-9.]*$"
                    onChange={e => {
                      if (!e.target.validity.patternMismatch) {
                        onChangeUnitPrices(e)
                      }
                    }}
                  />
                  {customValidation.errorRank.status && (
                    <p style={{ color: "red" }}>
                      {customValidation.errorRank.message}
                    </p>
                  )}

                  <SButton
                    onClick={onSubmitUnitPrices}
                    className="mt-2 button"
                    style={{ float: "right" }}
                  >
                    登録
                  </SButton>
                </Col>
              </ModalBody>
            </Modal>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default EditFabric
